import styled from 'styled-components';
import { Box, Grid, Slider as MuiSlider } from '@mui/material';
import COLORS from '../../colors';

const StyledMaximumText = styled.p`
  font-size: 16px;
  color: ${COLORS.NEUTRAL_200};
  background-color: ${COLORS.NEUTRAL_900};
  padding: 14px;
  border-radius: 12px;
  margin: 0;
`;

const StyledMinimumText = styled.p`
  font-size: 10px;
  line-height: 10px;
  padding-bottom: 5px;
`;

const StyledMinimumNumber = styled.p`
  color: ${COLORS.NEUTRAL_200};
  font-size: 16px;
`;

const StyledSlider = styled(MuiSlider)`
  .MuiSlider-markLabel {
    color: ${COLORS.NEUTRAL_200};
  }
`;

interface SliderProps {
  minimumValue?: number;
  maximumValue: number;
  isDisabled?: boolean;
  showMinimumLabel?: boolean;
  value: number;
  step?: number;
  onChange: (event: Event, value: number | number[]) => void;
}

const Slider = ({
  minimumValue,
  maximumValue,
  isDisabled = false,
  showMinimumLabel = false,
  value,
  step,
  onChange
}: SliderProps) => {
  return (
    <Box width={'100%'} textAlign="center">
      <Grid container spacing={3} justifyContent="center" alignItems="center">
        {showMinimumLabel && (
          <Grid item>
            <Grid>
              <Grid item>
                <StyledMinimumText>
                  NATURAL
                  <br />
                  DELIVERY
                </StyledMinimumText>
              </Grid>
              <Grid item>
                <StyledMinimumNumber>{minimumValue}%</StyledMinimumNumber>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item xs={showMinimumLabel ? 9.5 : 10}>
          <StyledSlider
            aria-labelledby="continuous-slider"
            valueLabelDisplay="auto"
            min={minimumValue}
            max={maximumValue}
            disabled={isDisabled}
            value={value}
            step={step}
            onChange={onChange}
          />
        </Grid>
        <Grid item>
          <StyledMaximumText>{value}%</StyledMaximumText>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Slider;
